import { Button, Flex, Stack } from '@mantine/core';
import { IconArrowLeft, IconArrowRight } from '@tabler/icons-react';
import { useState } from 'react';
import ReactDiffViewer, { DiffMethod } from 'react-diff-viewer';

import { Template } from '@e-origin/shared';

interface DiffTemplatesProps {
  templates: Template[];
}

export const DiffTemplates: React.FC<DiffTemplatesProps> = ({ templates }) => {
  const [oldTemplateIdx, setOldTemplateIdx] = useState(1);
  const [newTemplateIdx, setNewTemplateIdx] = useState(0);

  const newStyles = {
    variables: {
      light: {
        codeFoldGutterBackground: '#6F767E',
        codeFoldBackground: '#E2E4E5',
      },
    },
  };

  const handleStep = (dir: -1 | 1) => {
    if (dir === -1 && newTemplateIdx === 0) return;
    if (dir === 1 && oldTemplateIdx === templates.length - 1) return;

    setOldTemplateIdx(oldTemplateIdx + dir);
    setNewTemplateIdx(newTemplateIdx + dir);
  };

  return (
    <Stack>
      <Flex justify="space-between">
        <Button type="button" variant="outline" size="lg" onClick={() => handleStep(-1)} disabled={newTemplateIdx === 0}>
          <IconArrowLeft />
          Previous diff
        </Button>
        <Button type="button" variant="outline" size="lg" onClick={() => handleStep(1)} disabled={oldTemplateIdx === templates.length - 1}>
          Next diff
          <IconArrowRight />
        </Button>
      </Flex>
      <ReactDiffViewer
        oldValue={JSON.stringify(templates[oldTemplateIdx], undefined, 4)}
        newValue={JSON.stringify(templates[newTemplateIdx], undefined, 4)}
        splitView={true}
        compareMethod={DiffMethod.WORDS}
        styles={newStyles}
        leftTitle={`Version ${templates[oldTemplateIdx].version}`}
        rightTitle={`Version ${templates[newTemplateIdx].version}`}
      />
    </Stack>
  );
};
